function OfferBar() {
  return (
    <>
      <section className="offer-bar center">
        <h1 className="offer-bar__title">
          FREE SHIPPING - EVERYTHING IS %15 OFF !!
        </h1>
      </section>
    </>
  );
}

export default OfferBar;
